export default "__VITE_ASSET__47ecd0c2__"